import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { MarketingTemplate } from "../../marketing.types";
import { requestGetMarketingTemplates } from "./getMarketingTemplates.request";

const useMarketingTemplates = (
  approved?: boolean,
  options?: QueryOptions<MarketingTemplate[], ApiServiceError<ApiError>>
) => {
  const { data: templates, ...rest } = useQuery({
    queryKey: ["marketing", "templates", { approved: Boolean(approved) }],
    queryFn: async () => await requestGetMarketingTemplates(approved),
    onError: toastServerError,
    ...options
  });

  return { templates: templates ?? [], ...rest };
};

export default useMarketingTemplates;
